// Where a marked range sits on the timeline, as fractions (0–1) of the track:
// `length` null for a start-only mark. Null until the duration is known, or
// when the range starts past the end.
export function getMarkedRangePosition(
  range: { start: number; end: number | null } | undefined,
  duration: number | null,
): { start: number; length: number | null } | null {
  if (!range || !duration || duration <= 0) return null;
  const start = Math.max(0, range.start);
  if (start >= duration) return null;
  const fraction = start / duration;
  if (range.end === null || range.end <= start) {
    return { start: fraction, length: null };
  }
  const end = Math.min(range.end, duration);
  return { start: fraction, length: (end - start) / duration };
}

export interface VideoQualityOption {
  label: string;
  src: string;
}

// Processed renditions, highest first. The original upload is not offered:
// it may be a codec the browser cannot play (e.g. QuickTime).
export function getVideoQualityOptions(urls?: {
  video1080p?: string | null;
  video720p?: string | null;
  video480p?: string | null;
}): VideoQualityOption[] {
  if (!urls) return [];
  return [
    { label: '1080p', src: urls.video1080p },
    { label: '720p', src: urls.video720p },
    { label: '480p', src: urls.video480p },
  ].filter((option): option is VideoQualityOption => Boolean(option.src));
}
